enum RoomType{
    None = "None",
    Room = "Room",
    Apartment = "Apartment",
}

export default RoomType;